import React, { useContext, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";
import './css/menu.css';
import './css/onprinttoggle.css';
import Image from 'react-bootstrap/Image';
import Logo from '../../margretlogo.png';
import { GiRead } from "react-icons/gi";
import { FaChalkboardTeacher, FaUserTie } from "react-icons/fa";
import { TbReportAnalytics } from "react-icons/tb";
const Menu = () => {
    const location = useLocation();
    return (
        <div className="usr_menu print_hide">
            <br />
            <center><Image src={Logo} style={{ width: 80, height: 90 }} /></center>
            <center><h6>خوێندنگە</h6></center>
            <ul>
                <Link to="/school/"><li className={location.pathname == '/school/' ? 'aactive' : null}> <GiRead style={{ marginLeft: 15 }} /> فێرخواز</li></Link>
                {/* <Link to="/school/teacher"><li className={location.pathname == '/school/teacher' ? 'aactive' : null}> <FaChalkboardTeacher style={{ marginLeft: 15 }} /> مامۆستا</li></Link> */}
                {/* <Link to="/school/employ"><li className={location.pathname == '/school/employ' ? 'aactive' : null}> <FaUserTie style={{ marginLeft: 15 }} /> کارمەند</li></Link> */}
                <Link to="/school/studentaccount"><li className={location.pathname == '/school/studentaccount' ? 'aactive' : null}><TbReportAnalytics style={{ marginLeft: 15 }} /> هەژماری فێرخواز</li></Link>
                <Link to="/school/dailyexpense"><li className={location.pathname == '/school/dailyexpense' ? 'aactive' : null}><TbReportAnalytics style={{ marginLeft: 15 }} /> خەرجی ڕۆژانە </li></Link>
                <Link to="/school/mainreport"><li className={location.pathname == '/school/mainreport' ? 'aactive' : null}> <TbReportAnalytics style={{ marginLeft: 15 }} /> ژمێریاری گشتی</li></Link>
                {/* <Link to="/school/teacheraccount"><li className={location.pathname == '/school/teacheraccount' ? 'aactive' : null}><TbReportAnalytics style={{ marginLeft: 15 }} /> هەژماری مامۆستا</li></Link> */}
                {/* <Link to="/school/employaccount"><li className={location.pathname == '/school/employaccount' ? 'aactive' : null}><TbReportAnalytics style={{ marginLeft: 15 }} /> هەژماری کارمەند</li></Link> */}
            </ul>
        </div>
    )
}

export default Menu